import apiFetch from '../apiFetch'

export default function (idPedido, token) {
  return apiFetch({endPoint: `Pedido/eliminarPedido?idPedido=` + idPedido, method: 'GET', body: null, token: token})
}
